module.exports = __webpack_public_path__ + "static/img/16.5320286.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/4/zh/16.png
// module id = qCZn
// module chunks = 0